import { render, staticRenderFns } from "./Montages.vue?vue&type=template&id=9f944690&scoped=true"
import script from "./Montages.vue?vue&type=script&setup=true&lang=ts"
export * from "./Montages.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Montages.vue?vue&type=style&index=0&id=9f944690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f944690",
  null
  
)

export default component.exports